import { Component, OnInit } from '@angular/core';
import {DeviceType, LayoutID} from "../../model/device-type.model";
import {DeviceService} from "../../device/device.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {DeviceAttribute} from "../../model/device-attribute.model";
import {MatDialog} from "@angular/material/dialog";
import {DeviceAttributeDialogComponent} from "../device-attribute-dialog/device-attribute-dialog.component";
import {UtilService} from "../../shared/util.service";

@Component({
    selector: 'app-device-type-edit',
    templateUrl: './device-type-edit.component.html',
    standalone: false
})
export class DeviceTypeEditComponent implements OnInit {
  type: DeviceType;
  attributes: DeviceAttribute[];
  configs = [];
  newType = true;
  layouts = [];

  constructor(
    private service: DeviceService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private util: UtilService
  ) { }

  ngOnInit(): void {
    this.initPage();
    this.layouts = Object.entries(LayoutID);
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/data/device-type']);
      } else {
        if (id === 'new') {
          this.newType = true;
          this.type = new DeviceType();
        } else {
          this.newType = false;
          this.fetchItem(id);
        }
      }
    })
  }

  fetchItem(id) {
    this.service.getType(id).subscribe((resp:any) => {
      if (resp && resp.id) {
        this.type = new DeviceType(resp);
        this.fetchAvailableAttributes();
      }
    })
  }

  fetchAvailableAttributes() {
    this.service.getAvailableAttributes(this.type.id).subscribe((resp:any) => {
      if (resp.attributes) {
        this.attributes = (resp.attributes && resp.attributes.length) ? resp.attributes.map(r => new DeviceAttribute(r)) : [];
      }
      if (resp.yml) {
        this.configs = Object.values(resp.yml);
      }
    })
  }

  saveType() {
    this.service.saveType(this.type, this.newType).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open('Mentve');
      if (this.newType) {
        this.type = new DeviceType(resp);
        this.fetchAvailableAttributes();
        this.router.navigate(['/data/device-type', resp.id]);
      }
    })
  }

  onEditAttributeClick(attribute) {
    this.openAttributeDialog(attribute);
  }

  onDeleteAttributeClick(attribute) {
    this.service.confirmAction("Biztos törlöd ezt a tulajdonságot ebből a típusból?").subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.deleteAttribute(attribute);
      }
    })
  }

  deleteAttribute(attribute) {
    if (!this.attributes || !this.attributes.length) {
      this.attributes = [];
    }
    this.attributes.push(attribute);
    this.util.findAndReplaceItemInArray(attribute, this.type.attributes, true);
    this.saveType();
  }

  onNewAttributeClick() {
    this.openAttributeDialog();
  }

  onAddAttribute(attr) {
    this.util.findAndReplaceItemInArray(attr, this.attributes, true);
    this.type.attributes.push(attr);
    this.saveType();
  }

  openAttributeDialog(attribute?: DeviceAttribute) {
    let isEdit = attribute && attribute.id;
    const dialogRef = this.dialog.open(DeviceAttributeDialogComponent, {
      data: {
        item: attribute ? Object.assign(new DeviceAttribute(), attribute) : new DeviceAttribute(),
        type: this.type.id,
        isEdit: isEdit
      },
      minWidth: '300px',
      maxWidth: '500px'
    });

    dialogRef.afterClosed().subscribe( (result: DeviceAttribute) => {
      if (result) {
          if (isEdit) {
            this.type.attributes= this.util.findAndReplaceItemInArray(result, this.type.attributes);
          } else {
            this.type.attributes.push(result)
          }
      }
    });
  }

  handleTypeDelete() {
    this.service.deleteType(this.type.id).subscribe((resp:any) => {
      if (resp.success) {
        this.service.notiService.open("Sikeres törlés");
        return this.router.navigate(['/data/device-type']);
      }
    })
  }

  deleteType() {
    this.service.confirmAction("Biztosan törlöd ezt a típust?").subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.handleTypeDelete()
      }
    })
  }

  onAttrTypeChange(attr) {
    this.service.saveAttributeConfig(this.type, attr).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open("Attribute type assigned.");
    });
  }
}
